export interface IAppConfig {
    LocalStorageKey: Record<string, string>;
  }
  
  export class AppConfig implements IAppConfig {
    private static _instance: IAppConfig;
    public static get Instance() {
      return this._instance || (this._instance = new this());
    }
  
    readonly LocalStorageKey = {
      accessToken: "t__living_pp_access_token",
    };
  }
  